import React from 'react'

export default function VisiGiftCashHistory() {
  return (
    <div>VisiGiftCashHistory</div>
  )
}
